module.exports = __webpack_public_path__ + "media/video.0ecf52c6.mp4";